import React, { useState, useEffect } from "react";
import "./planpagelayout.css";
import { useDispatch, useSelector } from "react-redux";
import {
  QuickQuoteLife,
  ErrQuotesLife,
  PostQuoteLife,
} from "../../Redux/actions/NumLife";
import { Button, Form, message, Checkbox, Input } from "antd/lib";
import LifeCoverData from "../Number LifePage/LifeCoverData";
import axiosInLife from "../../Redux/axios/AxiosInLife";
import LifeCoverEdit from "../Number LifePage/CoverEdit";

export default function LifeCover({ setisModalMultiYr }) {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const LifeNum = useSelector((state) => state?.lifedetail?.lifenum);
  const QuotePost = useSelector((state) => state?.lifedetail?.QuickQuotePost);
  const SQQPlanMode = useSelector((state) => state?.common?.selectedLifePlan);
  const [loading, setLoading] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const [SumInsurArray, setSumInsurArray] = useState(LifeCoverData);
  const [sumPropValue, setSumPropValue] = useState(undefined);

  const onChangeBox = (e, i) => {
    console.log(e);
    setSelectedValue(i);
    setSumPropValue(e?.value);
  };

  const onCheckboxChange = (e, i) => {
    console.log(e);
    setSelectedValue(i);
    setSumPropValue(e?.value);
  };
  // console.log('selectedValue',selectedValue)

  const onSumInsurChange = (e) => {
    const value = e.target.value;
    console.log("value", value);
    if (value) {
      const filteredOptions = LifeCoverEdit?.filter(
        (option) => option?.label === value
      );
      setSelectedValue(null);
      setSumPropValue(undefined);
      console.log("filteredOptions", filteredOptions);
      setSumInsurArray(filteredOptions);
    } else {
      setSumInsurArray(LifeCoverData);
    }
  };
  console.log("sumPropValue", sumPropValue);
  const onFinish = (values) => {
    console.log("product values", values);
    const CustomInput = values?.custom_sum_input;
    const selectedAmount = sumPropValue;
    const CommonAmount = CustomInput ? CustomInput : selectedAmount;
    if (selectedAmount || CustomInput) {
      console.log("inside");
      const UpdatePlan = {
        ...QuotePost,
        SumProposed: CommonAmount,
      };
      setLoading(true);
      axiosInLife
        .post(
          `v1/life_insurances/${LifeNum?.insurance_id}/quick_quotes`,
          UpdatePlan
        )
        .then((res) => {
          if (res.status === 200) {
            const data = res?.data?.data;
            console.log(data);
            // const errData = data?.filter(item => ("status" in item && item.status === "failed"));
            // dispatch(ErrQuotesLife(errData));
            const filteredData = data?.filter(
              (item) => "status" in item && item.status === "success"
            );
            const updatedData = filteredData?.map((item) => ({
              ...item,
              responses: item.responses.map((response) => ({
                ...response,
                ...response[SQQPlanMode],
                insurer: item.insurer,
                logo: item.logo,
              })),
            }));
            dispatch(PostQuoteLife(UpdatePlan));
            dispatch(QuickQuoteLife(updatedData));
            setLoading(false);
            setisModalMultiYr(false);
          }
        })
        .catch((err) => {
          console.log(err.response.data.error);
          setLoading(false);
          message.error(err.response.data.error);
          setisModalMultiYr(false);
        });
    }
  };
  return (
    <>
      <Form
        form={form}
        onFinish={onFinish}
        layout="vertical"
        requiredMark={false}
        scrollToFirstError
      >
        <Form.Item
          className="mb-0"
          name="custom_sum_input"
          rules={[
            {
              pattern: /^[0-9]+$/,
              message: "Invalid Number",
            },
          ]}
        >
          <Input
            className="search-sum-insur"
            placeholder="Enter Manually"
            maxLength={8}
            onChange={onSumInsurChange}
          ></Input>
        </Form.Item>
        {SumInsurArray?.length > 0 && (
          <Form.Item
            name="lifeCover"
            rules={[
              {
                required: true,
                message: "Please select Sum Insured Amount",
              },
            ]}
            // initialValue={QuotePost?.policyPeriod}
          >
            <div className="life-pay-edit">
              {SumInsurArray?.map((e, i) => (
                <div
                  key={i}
                  className={
                    i === selectedValue
                      ? "life-edit-Active"
                      : "life-pay-edit-rb"
                  }
                  onClick={() => onChangeBox(e, i)}
                >
                  <span>
                    <Checkbox
                      checked={selectedValue === i}
                      onChange={() => onCheckboxChange(e, i)}
                    >
                      {e?.label}
                    </Checkbox>
                  </span>
                </div>
              ))}
            </div>
          </Form.Item>
        )}
        <div className="modal-btn-fxd">
          <Form.Item style={{ marginBottom: "0px" }}>
            <Button
              type="primary"
              htmlType="submit"
              className="update-qut-button"
              loading={loading}
            >
              Update
            </Button>
          </Form.Item>
        </div>
      </Form>
    </>
  );
}
